import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash.debounce'

/*
$tablet: 800px;
$desktop: 1200px;

@mixin tablet {
  @media screen and (min-width: #{$tablet}) {
    @content;
  }
}

@mixin desktop {
  @media screen and (min-width: #{$desktop}) {
    @content;
  }
}
 */

const isMobileWidth = (windowWidth) => windowWidth < 800
const isTabletWidth = (windowWidth) => windowWidth >= 800 && windowWidth < 1200
const isDesktopWidth = (windowWidth) => windowWidth >= 1200

const agrsMap = {
  mobile: 'isMobileWidth',
  tablet: 'isTabletWidth',
  desktop: 'isDesktopWidth',
}

/**
 *
 * @param {'mobile'|'tablet'|'desktop'} breakpoint
 * @returns {Object | boolean} without arg { isMobileWidth, isTabletWidth, isDesktopWidth } or boolean with arg
 */
const useBreakpointWidth = (breakpoint) => {
  const [windowWidth, setWindowWidth] = useState(null)
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth)
    }
    const debouncedHandleResize = debounce(handleResize, 150)
    window.addEventListener('resize', debouncedHandleResize)
    handleResize()
    return () => window.removeEventListener('resize', debouncedHandleResize)
  }, [])

  const widths = useMemo(() => {
    return {
      isMobileWidth: isMobileWidth(windowWidth),
      isTabletWidth: isTabletWidth(windowWidth),
      isDesktopWidth: isDesktopWidth(windowWidth),
    }
  }, [windowWidth])

  return breakpoint ? widths[agrsMap[breakpoint]] : widths
}

export default useBreakpointWidth
